/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Deselect_AllInputs */

const en_input_deselect_all = /** @type {(inputs: Input_Deselect_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deselect All`)
};

/**
* | output |
* | --- |
* | "Deselect All" |
*
* @param {Input_Deselect_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const input_deselect_all = /** @type {((inputs?: Input_Deselect_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Deselect_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_input_deselect_all(inputs)
});